// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"725":"e8f4f3ffceb66bb2","834":"ad022a5df92eeee4"}[chunkId] + ".js";
};